module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/why_3.626d080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/why/why_3.png
// module id = gc3E
// module chunks = 3